import { ReactComponent as DiplomaUnlocked } from "assets/images/diplomaUnlockedSmall.svg"
import { useGraphqlQuery } from "graphql-mock"
import { Card } from "materia"
import { useTranslation } from "react-i18next"
import { FiestaLink } from "utility-components"
import { WidgetLink } from "../../../components/Widget"
import { DiplomaWidgetMobileError } from "./DiplomaWidgetMobileError"
import { DiplomaWidgetMobileSkeleton } from "./DiplomaWidgetMobileSkeleton"
import { query, type Data } from "./gql"

import s from "./DiplomaWidgetMobile.module.scss"

export const DiplomaWidgetMobile = () => {
  const { data, isPending, error } = useGraphqlQuery(query, {
    page: 1,
    limit: 500, // high number to fetch all diplomas without using pagination
  })

  if (isPending) return <DiplomaWidgetMobile.Skeleton />
  if (error) return <DiplomaWidgetMobile.Error error={error} />

  return <DiplomaWidgetMobile.Load diplomas={data?.products.nodes} />
}

const Load = ({ diplomas }: { diplomas: Data["products"]["nodes"] }) => {
  const { t } = useTranslation()

  if (!diplomas.length) return null

  const count = diplomas.filter((diploma) => diploma.progress.certified).length
  const maxCount = diplomas.length

  return (
    <Card>
      <FiestaLink to="/me" ariaLabel="Open my profile">
        <div className={s.widget}>
          <div className={s.diploma}>
            <div className={s.diploma__content}>
              <div className={s.diploma__icon}>
                <DiplomaUnlocked />
              </div>
              <div className={s.diploma__info}>
                <div className={s.diploma__heading}>
                  {t("diploma.CERTIFICATES")}
                </div>
                <div className={s.diploma__text}>
                  {count} / {maxCount} {t("diploma.WIDGET_ATTAINED")}
                </div>
              </div>
            </div>

            <WidgetLink to="/me" ariaLabel="Open my profile" />
          </div>
        </div>
      </FiestaLink>
    </Card>
  )
}

DiplomaWidgetMobile.Skeleton = DiplomaWidgetMobileSkeleton
DiplomaWidgetMobile.Error = DiplomaWidgetMobileError
DiplomaWidgetMobile.Load = Load
